export default function useGetUserRole({ user }) {
  const isAdminRole = user?.rol?.nombre === "Administrador";
  const isInstitucionRole = user?.rol?.nombre === "Institución";
  const isCiudadanoRole = user?.rol?.nombre === "Usuario";
  return { isAdminRole, isInstitucionRole, isCiudadanoRole };
}
